import { useSplashscreen } from '@/app/hooks/useSplashscreen';
import { useMeQuery } from '@/features/Shared/api/me';

interface Props {
	children?: React.ReactNode;
}

export const OrganizationPreloadLayout = ({ children }: Props) => {
	const { data, isLoading, isError } = useMeQuery();
	const { hide: hideSplashScreen } = useSplashscreen();

	if (isLoading) {
		return <></>;
	}

	void hideSplashScreen();

	if (isError) {
		return <></>;
	}
	const organizations = data?.organizations ?? [];

	if (!organizations.length) {
		return <></>;
	}

	return <>{children}</>;
};
